import DodoneStats from 'app/dodones/shared/Stats'
import DodoneCommentFieldTrigger from 'app/dodones/fields/comment/Trigger'
import DodoneGenericShowContext from 'app/dodones/generic/show/Context'

export default ({ dodone }) => {
  const { showCommentFieldTrigger } = useContext(DodoneGenericShowContext)

  return (
    <>
      <DodoneStats dodone={dodone} />
      {showCommentFieldTrigger && <DodoneCommentFieldTrigger dodone={dodone} />}
    </>
  )
}
